import * as React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { truncate } from '../fns/util';
function MainCaseStudy(props) {
    var item = props.item;
    return (React.createElement("div", { className: 'autonet-case-study' },
        React.createElement("div", { className: 'row align-bottom' },
            React.createElement("div", { className: 'column column-6' },
                React.createElement("div", { className: 'autonet-case-study-image-container element-flex' }, item.imgPath
                    ? React.createElement("img", { src: item.imgPath, alt: item.title })
                    : React.createElement("i", { className: 'fa-regular fa-image' }))),
            React.createElement("div", { className: 'column column-6' },
                React.createElement("div", { className: 'autonet-tag' }, item.caseStudyLabel),
                React.createElement("h2", null, item.title),
                React.createElement("p", null, item.description),
                React.createElement("div", { className: 'empori-buttons-container' },
                    React.createElement("a", { className: 'empori-button text-like', href: item.linkUrl, title: item.linkLabel },
                        React.createElement("i", { className: 'fa-regular fa-long-arrow-right' }),
                        item.linkLabel))))));
}
function ThumbnailCaseStudy(props) {
    return (React.createElement("div", { className: "autonet-case-study-thumbnail ".concat(props.index === props.activeIndex ? 'active' : 'inactive'), onClick: function () { return props.updateIndex(props.index); } },
        React.createElement("div", { className: 'autonet-tag' }, props.item.caseStudyLabel),
        React.createElement("h3", null, truncate(props.item.title, 61))));
}
export function CaseStudies(_a) {
    var items = _a.items;
    var _b = React.useState(0), activeIndex = _b[0], updateIndex = _b[1];
    var mainRef = React.useRef(null);
    var thumbRef = React.useRef(null);
    var ms = 300;
    React.useEffect(function () {
        if (!mainRef.current || !thumbRef.current) {
            return;
        }
        var mainIndex = mainRef.current.swiper.activeIndex;
        var thumbIndex = thumbRef.current.swiper.activeIndex;
        if (mainIndex !== activeIndex) {
            mainRef.current.swiper.slideTo(activeIndex, ms, false);
        }
        if (thumbIndex !== activeIndex) {
            thumbRef.current.swiper.slideTo(activeIndex, ms, false);
        }
    }, [activeIndex]);
    return (React.createElement("div", { className: 'autonet-case-studies' },
        React.createElement(Swiper, { speed: ms, ref: mainRef, autoHeight: true, spaceBetween: 20, slidesPerView: 1, onSlideChange: function (swiper) { return updateIndex(swiper.realIndex); } }, items.map(function (item, i) {
            return React.createElement(SwiperSlide, { key: item.contentId },
                React.createElement(MainCaseStudy, { index: i, activeIndex: activeIndex, item: item, updateIndex: updateIndex }));
        })),
        React.createElement("div", { className: 'autonet-case-studies-thumbnails' },
            React.createElement(Swiper, { speed: ms, ref: thumbRef, spaceBetween: 20, slidesPerView: window.innerWidth <= 800 ? 2 : 3, onSlideChange: function (swiper) { return updateIndex(swiper.realIndex); } }, items.map(function (item, i) {
                return React.createElement(SwiperSlide, { key: item.contentId },
                    React.createElement(ThumbnailCaseStudy, { index: i, activeIndex: activeIndex, item: item, updateIndex: updateIndex }));
            })))));
}
